export const getDefaultState = () => ({
});
export const state = getDefaultState();
